<template lang="pug">
div
  el-row
    el-col(:span="2")
    el-collapse
      el-collapse-item(:title="'Credenciados Geo'")
        el-table(:data="credeciadosGEO", style="width: 100%", max-height="600")
          el-table-column(prop="nome", label="Nome")
          el-table-column(prop="email", label="Email")
  el-row
    el-col(:span="2")
    el-collapse
      el-collapse-item(:title="'Credenciados Vistoria'")
        el-table(:data="credeciadosVistoria", style="width: 100%", max-height="600")
            el-table-column(prop="nome", label="Nome")
            el-table-column(prop="email", label="Email")
</template>

<script>
import { mapActions } from 'vuex'
export default {
  data () {
    return {
      loading: false,
      credeciadosGEO: [],
      credeciadosVistoria: []
    }
  },
  methods: {
    ...mapActions({
      getListCredenciados: 'listagemProcesso/getListCredenciados'
    }),
    getAllData () {
      this.getListCredenciados().then((credenciado) => {
        this.credeciadosVistoria = credenciado.filter(credenciado => credenciado.tipo === 'VISTORIADOR')
        this.credeciadosGEO = credenciado.filter(credenciado => credenciado.tipo === 'GEOMENSOR')
      })
    }
  },
  created () {
    this.getAllData()
  }
}
</script>



// WEBPACK FOOTER //
// src/screens/portal/publico/components/informacao/ListagemCredenciados.vue